import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {GhouseMaidModel} from '../models/ghouseMaid.model';

@Injectable({
  providedIn: 'root'
})
export class GHouseMaidService {

  private host:string = environment.api+'/ghousemaids';
  private corsHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': 'http://localhost:4200'
  });

  constructor(private http: HttpClient) { }

  public getAllHouseMaids(){
    return this.http.get(this.host+'/findAll');
  }

  public CreateHouseMaid(ghouseMaid:GhouseMaidModel){
    return this.http.post(this.host,ghouseMaid);
  }

  public UpdateHouseMaid(ghouseMaid:GhouseMaidModel){
    return this.http.put(this.host,ghouseMaid);
  }

  public DeleteHouseMaid(gHouseMaid:GhouseMaidModel){
    return this.http.delete(this.host+'/'+gHouseMaid.gHouseMaidId);
  }
}
